import { connect } from 'react-redux'
import {
  setPickupPersonFormField,
  setPickupPersonForm
} from 'actions/account/pickupPeople'

import { setErrorMessage } from 'actions/account'

const mapStateToProps = ({ pickupPeople: { form } }) => ({ form })

const actions = {
  setPickupPersonFormField,
  setPickupPersonForm,
  setErrorMessage
}

const withRedux = connect(mapStateToProps, actions)

export default withRedux
